"use client"
import { useRouter } from "navigation"
import { Controller, useForm } from "react-hook-form"
import CustomSelectField from "../../contact/_components/CustomSelectField"
import { useTranslations } from "next-intl"

const PartnersTermsDropdown = ({location}) => {
  const t =  useTranslations('partnersTerms')
    const router = useRouter()
    const options = [
        {
          title: t(`dropdown-options.row.title`),
          value: 'row',
        },
        {
          title: t(`dropdown-options.uk.title`),
          value: 'uk',
        },
        {
          title: t(`dropdown-options.americas.title`),
          value: 'americas',
        },
      ]
      const getInitialSelectedItem = (location) => {
      const selectedItem = options.find(option => option.value === location)
      return selectedItem
      }
  const handleCountryChange = (e) => {
    if (e.value === 'location') return
    const selectedOpt = options.find(opt => opt.title === e)
    router.push(`/partners-terms/${selectedOpt?.value}`, undefined, { shallow: false }) // Update URL without reloading the page
  }

  const {
    control,
  } = useForm({
    defaultValues: {
      companySize: 'Rest of world',
    },
    mode: 'onChange',
  })
  return (
    <div className='col-span-8 relative mb-[70px]'>
    <Controller
      name='companySize'
      control={control}
      render={({ field }) => (
        <CustomSelectField
          isBoldSelectedOption
          containerClassName='w-full sm:w-1/2 md:w-5/12 lg:w-1/4'
          innerContainerClassName='!py-[15px]'
          options={options}
          initialSelectedTitle = {getInitialSelectedItem(location)}
          {...field}
          onChange={(e) => handleCountryChange(e)}
          ref={null}
        />
      )}
    />
  </div>
  )
}

export default PartnersTermsDropdown